// SPDX-FileCopyrightText: 2024 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { translateFromPresentation } from "@sequentech/ui-core";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { configuredLanguage } from "./usePresentationName";
export var MISSING_ALIAS = "-";
var isPlainObject = function (value) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
};
export function useAliasRenderer() {
    var i18n = useTranslation().i18n;
    // Fallback order: the interface language, then the given default language or
    // the record's own, then English.
    var aliasRenderer = useCallback(function (item, defaultLang) {
        var t = function (x) {
            var fallback = defaultLang !== null && defaultLang !== void 0 ? defaultLang : configuredLanguage(x);
            return (translateFromPresentation(x, "alias", i18n.language) ||
                translateFromPresentation(x, "name", i18n.language) ||
                (fallback
                    ? translateFromPresentation(x, "alias", fallback) ||
                        translateFromPresentation(x, "name", fallback)
                    : undefined) ||
                translateFromPresentation(x, "alias", "en") ||
                translateFromPresentation(x, "name", "en") ||
                MISSING_ALIAS);
        };
        if (item == null)
            return MISSING_ALIAS;
        if (isPlainObject(item)) {
            return t(item);
        }
        var s = String(item).trim();
        if (!s)
            return MISSING_ALIAS;
        if (s.startsWith("{")) {
            try {
                return t(JSON.parse(s));
            }
            catch (_a) {
                return MISSING_ALIAS;
            }
        }
        return MISSING_ALIAS;
    }, [i18n.language]);
    return aliasRenderer;
}
